import { render } from "./HeaderNotificationsNotifyPlaceholder.vue?vue&type=template&id=72a76407&scoped=true"
import script from "./HeaderNotificationsNotifyPlaceholder.vue?vue&type=script&lang=js"
export * from "./HeaderNotificationsNotifyPlaceholder.vue?vue&type=script&lang=js"

import "./HeaderNotificationsNotifyPlaceholder.vue?vue&type=style&index=0&id=72a76407&lang=scss&scoped=true"

import exportComponent from "/var/www/vhosts/t-socialposterexpertise-240125/project/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-72a76407"]])

export default __exports__